<ng-content></ng-content>
<mat-divider></mat-divider>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/article/article-header/article-header.component.html